import '@/assets/icomoon/style.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import "./main.styl"
import '@/assets/global.css'

Vue.use(Vuetify, {

})
